import React from 'react'
import { useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import { Trans, t } from '@lingui/macro'

import { linkBuilder } from '../../../../shared/linkBuilder'
import { navigateTo } from '../../app/util/appHistory'
import { ButtonClean, ButtonPrimary } from 'front-end/src/components'
import { notification } from '../../components/common/notifications/Notifications'
import { Modal } from '../../components/common/modal/Modal'
import { ISurvey } from './types'

interface IProps {
  show: boolean
  onHide: () => void
  survey: ISurvey
}

interface IResponseData {
  admin: { duplicateSurvey: { id: number } }
}

const duplicateSurveyMutation = gql`
  mutation duplicateSurvey($id: PositiveInt!) {
    admin {
      duplicateSurvey(id: $id) {
        id
      }
    }
  }
`

export default ({ show, onHide, survey }: IProps) => {
  const [duplicateSurvey, { loading }] = useMutation<
    IResponseData,
    { id: number }
  >(duplicateSurveyMutation)

  return (
    <Modal
      className="DuplicateSurveyModal"
      header={t`Copy survey`}
      show={show}
      onHide={onHide}
      controls={[
        <ButtonClean key={1} onClick={onHide}>
          <Trans>Close</Trans>
        </ButtonClean>,
        <ButtonPrimary
          isLoading={loading}
          type={'submit'}
          key={2}
          onClick={async () => {
            const { data } = await duplicateSurvey({
              variables: { id: survey.id }
            })
            if (data && data.admin.duplicateSurvey.id) {
              notification.info(t`Survey successfully copied`)
              navigateTo(
                linkBuilder.surveyDetailManage(data.admin.duplicateSurvey.id)
              )
            } else {
              notification.error(t`Unable to copy survey. Please try again.`)
            }
          }}
        >
          <Trans>Copy</Trans>
        </ButtonPrimary>
      ]}
    >
      <Trans>
        Do you want to copy <strong>{survey.title}</strong> survey?
      </Trans>
    </Modal>
  )
}
